// src/stage2/sceneExterior/ChainGateField.jsx
import React from "react";
import { ChainGate } from "./ChainGate";

function add3(a, b) {
  return [a[0] + b[0], a[1] + b[1], a[2] + b[2]];
}

function makeLine({
  idPrefix = "line",
  start = [0, 0, 0],
  count = 5,
  spacing = 4,
  axis = "x",
  baseRotation = [0, 0, 0],

  // NEW:
  yStep = 0,                 // easy slope: each segment y += i*yStep
  overrides = {},            // per-index overrides
}) {
  const [sx, sy, sz] = start;
  const data = [];

  for (let i = 0; i < count; i++) {
    const offset = i * spacing;

    // base position along axis
    let pos =
      axis === "x"
        ? [sx + offset, sy + i * yStep, sz]
        : axis === "z"
        ? [sx, sy + i * yStep, sz + offset]
        : [sx, sy + i * yStep, sz];

    let rot = baseRotation;

    // apply per-index override
    const o = overrides[i];
    if (o) {
      // absolute position override (if you want)
      if (o.position) pos = o.position;

      // relative nudge
      if (o.nudge) pos = add3(pos, o.nudge);

      // convenient y-only tweak
      if (typeof o.y === "number") pos = [pos[0], pos[1] + o.y, pos[2]];

      // rotation override
      if (o.rotation) rot = o.rotation;
    }

    data.push({
      id: `${idPrefix}-${axis}-${i}`, // ✅ unique
      position: pos,
      rotation: rot,
    });
  }

  return data;
}

export function ChainGateField() {
  const lineA = makeLine({
    idPrefix: "garden",
    start: [-34.5, 1.55, 6.5],
    count: 8,
    spacing: 2.75,
    axis: "x",
    baseRotation: [0, 0, 0],
    // EXAMPLE: tiny hill tweaks
    overrides: {
      2: { y: 0.15 },
      3: { y: 0.25 },
      4: { y: 0.30 },
      5: { y: 0.22 },
    },
  });

  const lineB2 = makeLine({
    idPrefix: "neighborhood",
    start: [38.5, 0.15, -1],
    count: 4,
    spacing: 3,
    axis: "z",
    baseRotation: [0, 1.5, 0],
    // EXAMPLE: rotation “fudge” on one segment
    overrides: {
      1: { rotation: [0, 1.52, 0], nudge: [0.02, 0, -0.03] },
    },
  });

  const lineC = makeLine({
    idPrefix: "parking",
    start: [-35.75, 0.75, -6.5],
    count: 4,
    spacing: 3,
    axis: "z",
    baseRotation: [0, 1.558, 0],
    // EXAMPLE: simple slope instead of many overrides
    yStep: 0.08,
  });

  const allSegments = [...lineA, ...lineB2, ...lineC];

  return (
    <group>
      {allSegments.map((seg) => (
        <ChainGate
          key={seg.id}
          position={seg.position}
          rotation={seg.rotation}
          scale={1.1}
        />
      ))}
    </group>
  );
}
